import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import FormSelect from '../Form/FormSelect';
import FormTextField from '../Form/FormTextField';
import Subtitle from "../Shared/Subtitle";
import options from "../Config/options";

const JobSchedule = props => {
    const [cron, setCron] = useState(props.schedule || 'cron(0 0 * * ? *)')
    const [frequency, setFrequency] = useState('daily')
    const [inputProps, setInputProps] = useState({});
    const [mm, setMm] = useState("00")
    const [hh, setHh] = useState("00")

    useEffect(() => {
        convertFromCron(props.schedule)
    }, [props.schedule])


    useEffect(() => {
        let newCron = cron
        switch (frequency) {
            case 'hourly':
                newCron = `cron(${parseInt(mm, 10)} 0/1 * * ? *)`;
                localize(frequency, 0);
                break;
            case '12hrmf':
                newCron = `cron(${parseInt(mm, 10)} 12-0 * * ? MON-FRI)`;
                localize(frequency, 12);
                break;
            case 'daily':
                newCron = `cron(${parseInt(mm, 10)} ${hh} * * ? *)`;
                setInputProps({});
                break;
            default:
                setInputProps({});
                break;
            // newCron = 'cron(0 0 * * ? *)';
        }
        setCron(newCron)
    }, [frequency, mm, hh])

    const localize = (freq, hr) => {
        const frozen = options.frequency.find(x => x.value === freq)?.frozen

        const date = new Date();
        date.setUTCHours(hr)
        const newHr = date.getHours().toString().padStart(2, '0')

        frozen && setInputProps({
            min: `${newHr}:00`,
            max: `${newHr}:59`,
        });

        setHh(newHr)
    }

    const setHhMm = (hr, mi, utc = false) => {
        const date = new Date();
        date.setMinutes(parseInt(mi, 10));
        date.setHours(parseInt(hr, 10));
        utc && date.setUTCMinutes(parseInt(mi, 10));
        utc && date.setUTCHours(parseInt(hr, 10));

        setMm(date.getMinutes().toString().padStart(2, '0'));
        setHh(date.getHours().toString().padStart(2, '0'));
    }

    const convertFromCron = sch => {
        let [mi, hr, dom, mo, dow, yy] = sch.replace(/[cron()]/g, '').split(' ')
        if (hr.split("/")[1]) {
            setFrequency("hourly")
            hr = "00"
        } else if (hr === '12-0') {
            setFrequency("12hrmf")
            hr = "12"
        } else if (dom + mo + dow + yy === "* * ? *") {
            setFrequency("daily")
        } else {
            setFrequency("custom")
        }
        setHhMm(hr, mi, true)

    }

    const handleChange = e => {
        const node = e.target.name
        if (node === "Frequency") {
            setFrequency(e.target.value)
        } else if (node === "Time") {
            setHhMm(
                e.target.value.split(':')[0],
                e.target.value.split(':')[1]
            )
        } else if (node === "Cron") {
            setCron(e.target.value)
        }
    }


    return (
        <Grid container className="Container">
            <Subtitle
                type="Schedule"
            />
            <Grid item xs={6}>
                <FormSelect
                    name='Frequency'
                    label='Frequency'
                    value={frequency}
                    disabled={props.disabled}
                    options={options.frequency}
                    handler={handleChange}
                />
                {frequency === "custom" &&
                    <FormTextField
                        name="Cron"
                        value={cron}
                        disabled={props.disabled}
                        handler={handleChange}
                    />
                }
            </Grid>
            <Grid item xs={6} sx={{ mt: 0.125, pr: 1 }}>
                <FormTextField
                    name="Time"
                    type="time"
                    label='Start Time'
                    value={`${hh}:${mm}`}
                    disabled={props.disabled || frequency === "custom"}
                    handler={handleChange}
                    inputProps={{
                        inputProps: {
                            step: 300, // 5 min
                            ...inputProps
                        }
                    }}

                />
            </Grid>
        </Grid>
    )
}
export default JobSchedule;